// src/elements/Table/Table.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Table = _ref => {
  let {
    children,
    className
  } = _ref;
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    /* @__PURE__ */
    jsx("div", {
      className: clsx("pd:table-scroller", className),
      role: "region",
      tabIndex: 0,
      children: /* @__PURE__ */jsx("table", {
        className: "pd:table",
        children
      })
    })
  );
};
var Table_default = Table;
export { Table_default };